import React from 'react';
import { Box } from '@mui/material';

const exceptions = [
  { type: 'approval-pending', count: 3, label: 'Approval Pending' },
  { type: 'price-mismatch', count: 2, label: 'Price Mismatch' },
  { type: 'po-mismatch', count: 2, label: 'PO Mismatch' },
  { type: 'missing-docs', count: 2, label: 'Missing Documents' },
  { type: 'qty-mismatch', count: 1, label: 'Qty Mismatch' },
  { type: 'tax-issue', count: 1, label: 'Tax Issue' },
];

export default function InvoiceExceptionsCard() {
  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">Invoice Exceptions</h3>
        <span className="click-tag">Click to filter invoices</span>
      </div>
      <div id="finExceptionGrid" className="exception-grid">
        {exceptions.map((ex) => (
          <Box
            key={ex.type}
            className="exception-chip"
            onClick={() => window.finExceptionClick?.(ex.type, {})}
          >
            <div className="ec-count">{ex.count}</div>
            <div className="ec-label">{ex.label}</div>
          </Box>
        ))}
      </div>
    </Box>
  );
}
